const apiKey = "AIzaSyA5h0ra_DpRn2ii7bN0kQb0yFfmZgQg-XE";

export const googleTranslate = require("google-translate")(apiKey);
